import {
  createContext, useContext, useEffect, ReactNode, useState,
} from 'react';
import { Role } from 'lib/types';
import { UserState } from 'lib/types/users';
import { useApi, useCurrentUser } from './ApplicationState';

type ProviderProps = { user: UserState; children: ReactNode };
const RolesContext = createContext<Role[] | undefined>(undefined);

function useUserRoles() {
  return useContext(RolesContext);
}

function UserRolesProvider({ user, children }: ProviderProps) {
  const [userId, setUserId] = useState<number|undefined>();
  const [roles, setRoles] = useState<Role[] | undefined>();
  const currentUser = useCurrentUser();
  const API = useApi();

  useEffect(() => {
    const getRoles = async () => {
      if (!user) return;

      const rolesData = await API.getUserRoles(user.id, true);
      setRoles(rolesData);
      setUserId(user.id);
    };
    if (user?.id !== userId || !roles) getRoles();
  }, [user, API, userId, currentUser, roles]);

  return (
    <RolesContext.Provider value={roles}>
      {children}
    </RolesContext.Provider>
  );
}

export { UserRolesProvider, useUserRoles };
